import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { API } from "../../config/api";
import "bulma/css/bulma.css";
import "../../index.css";
import Swal from "sweetalert2";
import swal from "sweetalert";

// Components
import ModalAddMedis from "./ModalAdmin/ModalAdd";
import ModalUpdateMedis from "./ModalAdmin/ModalUpdate";
import ModalDetailPatient from "./ModalAppointmentHistory/ModalDetail"
import ModalOdontogramPatient from "./ModalAppointmentHistory/ModalDetailOdontogram"
import LoaderHome from "../Loader/LoaderHome";
import HeaderAppointmentHistory from "./Components/HeaderAppointmentHistory";
import TableAppointmentHistory from "./Components/TableAppointmentHistory";
import WellcomeCard from "../Admin/Components/Wellcome";

export default function AppointmentHistoryDoctor() {
    document.title = "SDC Apps";

    const navigate = useNavigate();

    // ============================
    // STATE DEKLARASI
    // ============================
    const [getData, setGetData] = useState();
    const [pagination, setPagination] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pages, setPages] = useState(0);
    const [ascending, setAscending] = useState(0);
    const [rows, setRows] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");
    const [msg, setMsg] = useState("");
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);

    const idAdmin = localStorage.getItem("id_admin");

    const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);


    const [modalDetaiDataPatient, setModalDetailPatient] = useState(false);
    const [idDetailPatient, setIdDetailPatient] = useState();
    const [firstNamePastient, setFirstNamePastient] = useState();
    const [lastNamePatient, setLastNamePatient] = useState();
    const [genderPatient, setGenderPatient] = useState();
    const [codePatient, setCodePatient] = useState();
    const [dateBirthPatient, setDateBirthPatient] = useState();
    const [agePatient, setAgePatient] = useState();

    const [modalOdontogramPatient, setModalOdontogramPatient] = useState(false);
    const [idOdontogramPatient, setIdOdontogramPatient] = useState();
    const [toothNumberOdontogramPatient, setToothNumberOdontogramPatient] = useState();
    const [diagnosaPatient, setDiagnosaPatient] = useState();
    const [treatmentPatient, setTreatmentPatient] = useState();
    const [anamnesaPatient, setAnamnesaPatient] = useState();
    const [idAppointment, setIdAppointment] = useState();



    const [residenceAddressPatient, setResidenceAddressPatient] = useState();
    const [nicAddressPatient, setNicAddressPatient] = useState();
    const [phoneNumberPatient, setPhoneNumberPatient] = useState();
    const [nicNumberPatient, setNicNumberPatient] = useState();
    const [occupationPatient, setOccupationPatient] = useState();
    const [medicalRecordCodePatient, setMedicalRecordCodePatient] = useState();
    const [emailPatient, setEmailPatient] = useState();


    const [modalAdd, setModalAdd] = useState(false);
    const [modalUpdate, setModalUpdate] = useState(false);
    const [id, setId] = useState();
    const [nameUpdate, setNameUpdate] = useState();


    // Responsive
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 980px)" });

    let fetchParams = {
        headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
        },
    };

    const GetResponseData = async () => {
        try {
            setLoading(true);
            const response = await API.get(
                `emr-service/treatment-plans/doctor/${idAdmin}?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
                fetchParams
            );

            if (response?.status === 200) {
                const result = response?.data?.data;
                setGetData(Array.isArray(result?.data) ? result.data : []);
                setPage(result?.current_page || 1);
                setPages(result?.last_page || 0);
                setRows(result?.total || 0);
            }
        } catch (error) {
            if (error.response.status === 401) {
                navigate('/dashboard')
                swal({
                    title: 'Failed',
                    text: `Akses dibatasi Tidak Dapat Mengakses Halaman Ini`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            } else {
                swal({
                    title: 'Failed',
                    text: `${error.response.data.message}`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        GetResponseData();
        // GetResponseDataProfile();
    }, [page]);



    const deleteById = async (id) => {
        Swal.fire({
            title: "Apakah Kamu Yakin?",
            text: `Menghapus data ini`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ya, Hapus",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await API.delete(
                    `transaction-service/floors/${id}`,
                    fetchParams
                );
                if (response.data.error === false) {
                    GetResponseData();
                    swal({
                        title: "Success",
                        text: "Your data has been successfully deleted",
                        icon: "success",
                        timer: 3000,
                        buttons: false,
                    });
                }
            }
        });
    };

    const changePage = ({ selected }) => {
        setPage(selected + 1);
        setMsg("");
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeyword(query);
    };

    const buttonRefresh = () => {
        window.location.reload();
    };


    const modalDetailPatient = (id, firstname, lastname, gender, code, date_birth, age, residence_address, nic_address, phone_number, nic_number, occupation, medical_record_code, email) => {
        setModalDetailPatient(true)
        setIdDetailPatient(id)
        setFirstNamePastient(firstname)
        setLastNamePatient(lastname)
        setGenderPatient(gender)
        setCodePatient(code)
        setDateBirthPatient(date_birth)
        setAgePatient(age)
        setResidenceAddressPatient(residence_address)
        setNicAddressPatient(nic_address)
        setPhoneNumberPatient(phone_number)
        setNicNumberPatient(nic_number)
        setOccupationPatient(occupation)
        setMedicalRecordCodePatient(medical_record_code)
        setEmailPatient(email)
    }

    const modalOdontogramsPatient = (id, tooth_number, patient_firstname, patient_lastname, diagnosa, treatment, anamnesa, id_appointment) => {
        setModalOdontogramPatient(true)
        setIdOdontogramPatient(id)
        setToothNumberOdontogramPatient(tooth_number)
        setFirstNamePastient(patient_firstname)
        setLastNamePatient(patient_lastname)
        setDiagnosaPatient(diagnosa)
        setTreatmentPatient(treatment)
        setAnamnesaPatient(anamnesa)
        setIdAppointment(id_appointment)
    }



    return (
        <>
            <Row>
                <WellcomeCard
                    getDataProfileNull={getDataProfileDetail === null}
                    getDataProfileFirstName={getDataProfileDetail?.firstname}
                    getDataProfileLastName={getDataProfileDetail?.lastname}
                />
            </Row>

            <div
                style={{
                    backgroundColor: "white",
                    marginTop: "15px",
                    marginLeft: "10px",
                    marginRight: "10px",
                    boxShadow: "2px 2px 10px #BFBFBF",
                }}
            >

                {modalDetaiDataPatient && (
                    <ModalDetailPatient
                        show={modalDetaiDataPatient}
                        onHide={() => setModalDetailPatient(false)}
                        idDetailPatient={idDetailPatient}
                        firstNamePastient={firstNamePastient}
                        lastNamePatient={lastNamePatient}
                        genderPatient={genderPatient}
                        codePatient={codePatient}
                        dateBirthPatient={dateBirthPatient}
                        agePatient={agePatient}
                        residenceAddressPatient={residenceAddressPatient}
                        nicAddressPatient={nicAddressPatient}
                        phoneNumberPatient={phoneNumberPatient}
                        nicNumberPatient={nicNumberPatient}
                        occupationPatient={occupationPatient}
                        medicalRecordCodePatient={medicalRecordCodePatient}
                        emailPatient={emailPatient}
                    />
                )}

                {modalOdontogramPatient && (
                    <ModalOdontogramPatient
                        show={modalOdontogramPatient}
                        onHide={() => setModalOdontogramPatient(false)}
                        idOdontogramPatient={idOdontogramPatient}
                        diagnosaPatient={diagnosaPatient}
                        treatmentPatient={treatmentPatient}
                        toothNumberOdontogramPatient={toothNumberOdontogramPatient}
                        firstNamePastient={firstNamePastient}
                        lastNamePatient={lastNamePatient}
                        anamnesaPatient={anamnesaPatient}
                        idAppointment={idAppointment}
                    />
                )}



                {loading && <LoaderHome />}

                <HeaderAppointmentHistory
                    isTabletOrMobile={isTabletOrMobile}
                    query={query}
                    setQuery={setQuery}
                    searchData={searchData}
                    buttonRefresh={buttonRefresh}
                />

                <Col xl="12" sm="12">
                    <div>
                        <TableAppointmentHistory
                            getData={getData}
                            rows={rows}
                            page={page}
                            pages={pages}
                            changePage={changePage}
                            msg={msg}
                            id={id}
                            modalDetailPatient={modalDetailPatient}
                            modalOdontogramPatient={modalOdontogramsPatient}
                            nameUpdate={nameUpdate}
                            deleteById={deleteById}
                            isTabletOrMobile={isTabletOrMobile}
                        />
                    </div>
                </Col>
            </div>
        </>
    );
}
